/*
|--------------------------------------------------------------------------
| Tips
|--------------------------------------------------------------------------
| API URL
*/

const Api =  {
  rbac: {
    groupAddUrl: '/user/group/add',
    groupListUrl: '/user/group/list',
    groupDetailUrl: '/user/group/getdetail',
    groupEditUrl: '/user/group/edit',
    groupDeleteUrl: '/user/group/delete',
    shopAddUrl: '/user/shop/add',
    shopListUrl: '/user/shop/list',
    shopDetailUrl: '/user/shop/getdetail',
    shopEditUrl: '/user/shop/edit',
    shopDeleteUrl: '/user/shop/delete',
    shopResetKeyUrl: '/user/shop/resetKey',
    accountAddUrl: '/user/account/add',
    accountListUrl: '/user/account/list',
    accountDetailUrl: '/user/account/getdetail',
    accountEditUrl: '/user/account/edit',
    accountDeleteUrl: '/user/account/delete',
    accountSetStatusUrl: '/user/account/setstatus',
    roleAddUrl: '/user/role/add',
    roleListUrl: '/user/role/list',
    roleDetailUrl: '/user/role/getdetail',
    roleEditUrl: '/user/role/edit',
    roleDeleteUrl: '/user/role/delete',
    accountEditVlan: '/user/account/editVlan',
    // 门店列表
    getAllShopUrl: '/user/shop/allList',
    // AP型号列表
    getApListUrl: '/device/ap/allList',
    // 发货信息列表
    getShipmentListUrl: '/user/shipment/list',
    addShipment: '/user/shipment/add',
    // 发货信息操作
    shipmentOperateUrl: '/user/shipment/edit',
    // 删除发货信息
    deleteShipmentUrl: '/user/shipment/delete'
  },

  portal: {
    acListUrl: '/portal/authzone/list',
    zonenameListUrl: '/portal/authzone/zonenameList',
    acDetailUrl: '/portal/authzone/getdetail',
    acAddUrl: '/portal/authzone/add',
    acDeleteUrl: '/portal/authzone/delete',
    acEditUrl: '/portal/authzone/edit',
    acSetApmacsUrl: '/portal/authzone/setapmacs',
    acSetWebhookUrl: '/portal/authzone/setwebhook',
    acSetDefaultUrl: '/portal/authzone/setdefault',
    scheduleListUrl: '/portal/schedule/list',
    scheduleDetailUrl: '/portal/schedule/getdetail',
    scheduleAddUrl: '/portal/schedule/add',
    scheduleDeleteUrl: '/portal/schedule/delete',
    scheduleEditUrl: '/portal/schedule/edit',
    scheduleSetRulesUrl: '/portal/schedule/setrules',
    udemoListUrl: '/portal/page/list',
    udemoDetailUrl: '/portal/page/getdetail',
    udemoAddUrl: '/portal/page/add',
    udemoDeleteUrl: '/portal/page/delete',
    udemoEditUrl: '/portal/page/edit',
    udemoEditContentUrl: '/portal/page/editcontent',
    sdemoListUrl: '/portal/tpl/list',
    sdemoDetailUrl: '/portal/tpl/getdetail',
    sdemoAddUrl: '/portal/tpl/add',
    sdemoDeleteUrl: '/portal/tpl/delete',
    sdemoEditUrl: '/portal/tpl/edit',
    sdemoEditContentUrl: '/portal/tpl/editcontent',
    demoUploadContentUrl: '/portal/editor/upload',
    radcheckListUrl: '/radius/radcheck/listset',
    gatewayListUrl: '/sms/gateway/list',
    getApgroups: '/portal/authzone/getApgroups',
    setApgroups: '/portal/authzone/setApGroup',
    getPortalTypes: '/portal/portal/typeList',
    addPortalType: '/portal/portal/addType',
    delPortalType: '/portal/portal/delType'
  },
  system: {
    permissionListUrl: '/system/privilege/list',
    permissionDetailUrl: '/system/privilege/getdetail',
    permissionAddUrl: '/system/privilege/add',
    permissionDeleteUrl: '/system/privilege/delete',
    permissionEditUrl: '/system/privilege/edit',
    placeListUrl: '/system/location/list',
    placeDetailUrl: '/system/location/getdetail',
    placeAddUrl: '/system/location/add',
    placeDeleteUrl: '/system/location/delete',
    placeEditUrl: '/system/location/edit',
    opLogListUrl: '/system/log/op',
    radiusLogListUrl: '/system/log/radius',
    gatewayLogListUrl: '/system/log/gateway',
    auditLogListUrl: '/system/log/audit',
    smsLogListUrl: '/system/log/sms',
    getLcrFileUrl:'/system/license/getLcrFile',
    uploadLcsFileUrl:'/system/license/postLcsFile',
    getLcsStatusUrl:'/system/license/getLcsStatus',
    cancelLcsUrl:'/system/license/cancelLcs'
  }, 
  gateway:{
    deviceTobindlist:'/gateway/device/tobindlist',
    deviceBind:'/gateway/device/bind',
    deviceList:'/gateway/device/list',
    deviceGetDetail:'/gateway/device/getdetail',
    deviceEdit:'/gateway/device/edit',
    deviceAdd:'/gateway/device/add',
    deviceDelete:'/gateway/device/delete',
    deviceToaudit:'/gateway/device/toaudit',
    commandList:'/gateway/command/list',
    commandGetdetail:'/gateway/command/getdetail',
    commandExcute:'/gateway/command/excute',
    emailList: '/gateway/email/list',
    emailAdd: '/gateway/email/add',
    emailDelete: '/gateway/email/delete',
    emailEdit: '/gateway/email/edit',
    eamilTest:'/gateway/email/test',
    alertList: '/gateway/alert/list',
    alertAdd: '/gateway/alert/add',
    alertEdit: '/gateway/alert/edit',
    alertDelete: '/gateway/alert/delete',
    alertBindList:'/gateway/alert/bindList',
    alertBindAdd:'/gateway/alert/bindAdd',
    alertBindDelete:'/gateway/alert/bindDelete',
    alertRecordList:'/gateway/alertrecord/list',
    alertRcordExport:'/gateway/alertrecord/export'
  },
  device:{
    apGroupList: '/device/apgroup/list',
    addApGroup: '/device/apgroup/add',
    editApGroup: '/device/apgroup/edit',
    delApGroup: '/device/apgroup/del',    
    apInfo:'/device/ap/info', 
    apList: '/device/ap/list',
    addAp: '/device/ap/add',
    editAp: '/device/ap/edit',
    deviceList: '/device/device/list',
    addDeviceGroup: '/device/device/add',
    delAp: '/device/ap/del',
    getApimportTemplateUrl: '/device/ap/importTemplate',
    importAp: '/device/ap/import',
    switchList: '/device/switch/list',
    deviceInstallList: '/device/device/deviceInstallList',
    deviceInstallAdd: '/device/device/deviceInstallAdd',
  },
  auth:{
    loginUrl: '/home/user/login',

    authloginUrl: '/home/user/authlogin',

    logoutUrl: '/home/user/logout',
    modifypwd: '/home/user/modifypwd'
  },
  sms:{
    sdkList:'/sms/sdk/list',
    sdkAdd:'/sms/sdk/add',
    sdkDelete:'/sms/sdk/delete',
    gatewayList: '/sms/gateway/list',
    gatewayAdd: '/sms/gateway/add',
    gatewayEdit: '/sms/gateway/edit',
    gatewayDel: '/sms/gateway/delete',
    recordList: '/sms/record/list',
  },
  data:{
    userflowList:'/analysis/userflow/list',
    userflowDetail: '/analysis/userflow/show/id/',
    appList: '/analysis/applicationflow/list',
    deviceList: '/gateway/device/list',
    authList: '/analysis/authdetail/list',
    authtypeList: '/analysis/authdetail/authtypeList',
    offlineDevice: '/analysis/authdetail/offlineDevice',
    bindwidthup: '/analysis/bindwidth/up',
    bindwidthdown: '/analysis/bindwidth/down',
    bindwidthMonth: '/analysis/bindwidth/month',
    bindwidthDay: '/analysis/bindwidth/day',
    bindwidthHour: '/analysis/bindwidth/hour',
    screenProvince:'/Analysis/Screen/province',
    applicationflowTop:'/Analysis/Applicationflow/top',
    visitorList:'/analysis/authdetail/visitorList',
    exportAuthdetail: '/analysis/authdetail/export',
  },
  dashboard:{
    index: '/analysis/dashboard/index',
    getDev: '/analysis/dashboard/getdev',
    upflow: '/analysis/dashboard/upflow',
    downflow: '/analysis/dashboard/downflow',
    dayauth: '/analysis/dashboard/dayauth',
    connectdayauth: '/analysis/dashboard/connectdayauth',
    hourauth: '/analysis/dashboard/hourauth',
    connecthourauth: '/analysis/dashboard/connecthourauth',
    conntrend: '/Analysis/Dashboard/conntrend',
  },
  pick:{
    groupList: '/user/group/list',
    shopList: '/user/shop/list',
    deviceList: '/gateway/device/list',
  },
  aaa: {
    serverList: '/radius/server/list',
    serverAdd: '/radius/server/add',
    serverDelete: '/radius/server/delete',
    serverStatus: '/radius/server/status',
    serverRestart: '/radius/server/restart',
    serverSetport: '/radius/server/setport',
    clientList: '/radius/client/list',
    clientAdd: '/radius/client/add',
    clientDelete: '/radius/client/delete',
    clientEdit: '/radius/client/edit',
    radcheckListset: '/radius/radcheck/listset',
    radcheckAddset: '/radius/radcheck/addset',
    radcheckDeleteset: '/radius/radcheck/deleteset',
    radcheckAddsetattr: '/radius/radcheck/addsetattr',
    radcheckAddsetattrs: '/radius/radcheck/addsetattrs',
    radcheckDelsetattr: '/radius/radcheck/delsetattr',
    radcheckEditsetr: '/radius/radcheck/editset',
    radcheckListuser: '/radius/radcheck/listuser',
    radcheckAdduser: '/radius/radcheck/adduser',
    radcheckDeleteuser: '/radius/radcheck/deleteuser',
    radcheckAdduserattr: '/radius/radcheck/adduserattr',
    radcheckAdduserattrs: '/radius/radcheck/adduserattrs',
    radcheckDeluserattr: '/radius/radcheck/deluserattr',

    radcheckEdituser: '/radius/radcheck/edituser',

    radcheckWechatAdmins: '/radius/radcheck/wechatAdmins',
    radcheckGetQrcodeUrl: '/radius/radcheck/getQrcodeUrl',
    radcheckWechatAdminDel: '/radius/radcheck/wechatAdminDel',
    radcheckcheckNewWechatAdmin: '/radius/radcheck/checkNewWechatAdmin',
    radcheckVisitors: '/radius/radcheck/visitors',
    radcheckAddVisitor: '/radius/radcheck/addVisitor',
    radcheckDelVisitor: '/radius/radcheck/delVisitor',

    getDownloadTemplateUrl: '/radius/radcheck/downloadTemplate',
    importTemplate: '/radius/radcheck/importTemplate',
    radcheckListGroup: '/radius/radcheck/listclass',
    authClass: '/radius/radcheck/infoclass',
    authSet: '/radius/radcheck/infoset',
    radcheckAddGroup: 'radius/radcheck/addclass',
    radcheckAddGroupAttrs: 'radius/radcheck/addclassattrs',
    radcheckDelGroupAttr: 'radius/radcheck/delclassattr',
    radcheckEditGroup: 'radius/radcheck/editclass',
    radcheckDelGroup: 'radius/radcheck/deleteclass',
    radcheckSetUserEnable: 'radius/radcheck/setuserenable',
    getDownloadVisitorTemplateUrl: '/radius/radcheck/downloadVisitorTemplate',
    importVisitorTemplate: '/radius/radcheck/importVisitorTemplate',
    ldapList:'/ldap/ldap/list',
    ldapEdit:'/ldap/ldap/edit',
    ldapAdd:'/ldap/ldap/add',
    ldapDelete:'/ldap/ldap/delete'
  },
  audit: {
    deviceList: '/audit/device/list',
    deviceDelete: '/audit/device/delete',
    deviceEdit: '/audit/device/edit',
    deviceAdd: '/audit/device/add',
  }
}

export default Api